import {
  ShineStartDocument,
  ShineStartDocumentStatus,
} from '__generated__/GQL';
import getShineStartDocumentError from 'features/Onboarding/modules/ShineStartVerification/libs/getShineStartDocumentError';

const getShineStartVerificationErrors = ({
  documents,
}: {
  documents: Pick<ShineStartDocument, 'errorLocalized' | 'status' | 'error'>[];
}): string[] =>
  documents
    .filter((doc) => doc.status === ShineStartDocumentStatus.Refused)
    .map((doc) => getShineStartDocumentError(doc));

export default getShineStartVerificationErrors;
